
import React, { FC } from "react"
import { graphql, useStaticQuery } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"

import { BespokeComponentFragmentFragment, DelightLabsMediaBlockQueryQuery } from "@graphqlTypes"

import LpSection from "@components/lp/LpSection/LpSection"
import Media from "@components/lp/Media/Media"

import "./DelightLabsMediaBlock.scss"

const DelightLabsMediaBlock: FC<{
  contentful_id: BespokeComponentFragmentFragment["contentful_id"],
}> = ({
  contentful_id,
}) => {
    const {
      balloonDogImageData,
      explodingBeakerImageData,
      mainImageData,
    } = useStaticQuery<DelightLabsMediaBlockQueryQuery>(graphql`
    query DelightLabsMediaBlockQuery {
      mainImageData: contentfulAsset(contentful_id:{eq:"7GSk4xjCUHbOZGLlrXs2GZ"}) {
        imgixImage {
          gatsbyImageData(width: 1414)
        }
      }
      balloonDogImageData: contentfulAsset(contentful_id:{eq:"3zVBL3U8wEyZmcPQkYA1Cr"}) {
        imgixImage {
          gatsbyImageData(width: 387)
        }
      }
      explodingBeakerImageData: contentfulAsset(contentful_id:{eq:"3OeSdBoClrrOgroadcUkrD"}) {
        imgixImage {
          gatsbyImageData(width: 382)
        }
      }
    }
  `)

    return (
      <LpSection
        className="MediaBlock DelightLabsMediaBlock"
        uniqueId={contentful_id}
      >
        <div className="container">
          <div className="grid">
            <div className="image-comp column">
              {mainImageData && (
                <Media
                  image={mainImageData}
                  includeMediaBoxShadow
                />
              )}
              {balloonDogImageData?.imgixImage?.gatsbyImageData && (
                <GatsbyImage
                  alt="Balloon Dog"
                  className="image--balloon-dog"
                  image={balloonDogImageData.imgixImage.gatsbyImageData}
                />
              )}
              {explodingBeakerImageData?.imgixImage?.gatsbyImageData && (
                <GatsbyImage
                  alt="Exploding Beaker"
                  className="image--exploding-beaker"
                  image={explodingBeakerImageData.imgixImage.gatsbyImageData}
                />
              )}
            </div>
          </div>
        </div>
      </LpSection>
    )
  }

export default DelightLabsMediaBlock
